import 'choerodon-ui/lib/style/index.less';
import 'choerodon-ui/lib/collapse/style';
import 'choerodon-ui/lib/grid/style';
import 'choerodon-ui/lib/tag/style';
import 'choerodon-ui/lib/popover/style';
import 'choerodon-ui/lib/card/style';
import 'choerodon-ui/pro/lib/typography/style';
import 'choerodon-ui/pro/lib/table/style';
import './index.less';
// style dependencies
import '../../modal-container/style';
